import { createContext, createElement, Component } from 'react';
import t from 'prop-types';

var INIT_ACTION = "/simpleflux/@@init/";

function subscribe(name, fn, eventStore) {
  if (Array.isArray(name)) return name.map(function (n) {
    return subscribe(n, fn, eventStore);
  });

  if (!eventStore[name]) eventStore[name] = [];

  // mutate eventStore
  eventStore[name].push(fn);

  // return unsubscribe fn;
  var idx = eventStore[name].length - 1;
  return function () {
    eventStore[name].splice(idx, 1);
  };
}
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var emptyState = {};

  var shouldProc = function shouldProc(eventName, type) {
    if (!eventName) return true;
    if (typeof eventName === "string" && eventName === type) return true;
    if (Array.isArray(eventName) && eventName.indexOf(type) > -1) return true;

    return false;
  };

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;
    var action = arguments[1];

    var hasChanged = false;
    var nextState = {};
    if (!action || typeof action.type !== "string") {
      console.error("All actions must contain a type attribute, eg: { type: String, ... }, we will ignore your action", action);
      return state;
    }

    reducerKeys.forEach(function (key) {
      var reducer = reducers[key];
      var initialState = reducer.initialState,
          eventName = reducer.eventName;

      var previousStateForKey = state[key] || initialState;

      var nextStateForKey = shouldProc(eventName, action.type) ? reducer(previousStateForKey, action, state || {}) : previousStateForKey;

      if (typeof nextStateForKey === "undefined") {
        console.error("reducer named " + key + " returned undefined, you must return something !, we will just ignore your action for this key...");
        nextStateForKey = previousStateForKey || initialState;
      }

      nextState[key] = nextStateForKey;

      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    });

    return hasChanged ? nextState : state;
  };
}

function proxyArgToFns(x, store) {
  var selectors = {};
  for (var i in x) {
    selectors[i] = {};
    for (var ii in x[i]) {
      if (isFunction(x[i][ii])) {
        selectors[i][ii] = x[i][ii].bind(null, store);
      }
    }
  }
  return selectors;
}

function isFunction(fn) {
  return typeof fn === "function";
}

var asyncToGenerator = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var noob = function noob() {
  return null;
};

function hasRemoteDev() {
  return typeof window !== "undefined" && !!window.__REDUX_DEVTOOLS_EXTENSION__;
}

function buildRemoteDev() {
  if (hasRemoteDev() === false) return {
    send: noob,
    subscribe: noob,
    init: noob,
    extractState: noob
  };

  return require("remotedev").connectViaExtension();
}

var remotedev = buildRemoteDev();
var extractState = remotedev.extractState;

var Context = createContext({
  listen: noob,
  emit: noob,
  store: {}
});

var ReactPubFlux = function (_React$Component) {
  inherits(ReactPubFlux, _React$Component);

  function ReactPubFlux(props) {
    var _this2 = this;

    classCallCheck(this, ReactPubFlux);

    var _this = possibleConstructorReturn(this, (ReactPubFlux.__proto__ || Object.getPrototypeOf(ReactPubFlux)).call(this, props));

    _this.getState = function () {
      return _this.state;
    };

    _this.emit = function (event) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var skipActionCreator = arguments[2];
      var internalFn_globalOnly = arguments[3];

      if (skipActionCreator === true) {
        var action = _extends({ type: event }, data);
        var newState = _this.reducer(_this.state, action);
        remotedev.send(action, newState);

        // notify global actions of event..
        _this.emit(event, data, false, internalFn_globalOnly);

        // resolve promise
        return new Promise(function (resolve) {
          if (newState && newState !== _this.state) {
            _this.setState(newState, function () {
              return resolve(_this.state);
            });
          } else {
            return resolve(newState);
          }
        });
      }

      var actionCreators = [];

      if (Array.isArray(_this.emitter["*"])) {
        actionCreators = _this.emitter["*"];
      }

      if (Array.isArray(_this.emitter[event]) && internalFn_globalOnly !== true) {
        actionCreators = actionCreators.concat(_this.emitter[event]);
      }

      var promises = actionCreators.map(function () {
        var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(fn) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return fn(event, data, _this.emit, _this.getState);

                case 2:
                  return _context.abrupt("return", _context.sent);

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());

      return new Promise(function (resolve) {
        return Promise.all(promises).then(function (result) {
          return result.filter(function (r) {
            return r && typeof r.type === "string";
          });
        }).then(function (a) {
          return a.reduce(function (s, aa) {
            return _this.reducer(s, aa);
          }, _this.state);
        }).then(function (newState) {
          // Send changes to the remote monitor
          remotedev.send(_extends({ type: event }, data), newState);

          // resolve promise
          if (newState && newState !== _this.state) {
            _this.setState(newState, function () {
              return resolve(_this.state);
            });
          } else {
            return resolve(newState);
          }
        }).catch(function (e) {
          console.error("something bad happened while executing event:" + event, data);
          console.info(promises, e);
          return resolve(_this.state);
        });
      });
    };

    _this.listen = function (eventName, cb) {
      return subscribe(eventName, cb, _this.emitter);
    };

    _this.emitter = {};

    // adding actions
    if (!props.actions || props.actions.length < 1) {
      console.warn("no actions supplied");
    }

    Array.from(props.actions).filter(function (i) {
      return !!i;
    }).map(function (fn) {
      return subscribe(fn.eventName || "*", fn, _this.emitter);
    });

    _this.reducer = props.reducer;

    _this.state = _this.reducer(props.initialState || {}, {
      type: INIT_ACTION
    });

    remotedev.init(_this.state, { name: "iSchool Flux" });
    return _this;
  }

  createClass(ReactPubFlux, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      // Subscribe to change state (if need more than just logging)
      remotedev.subscribe(function (message) {
        // Helper when only time travelling needed
        var state = extractState(message);
        _this3.setState(state);
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // A hook for persisting to storage or whatever
      // @@todo: explore option to remove this and added it as callback to setState to avoid calling this on initalMount !
      // --------------------------------------------
      var onChange = this.props.onChange;


      if (isFunction(onChange)) {
        onChange(this.state);
      }
    }

    /**
     * return current AppState
     * @todo return a copy of state not actual, to prevent mutation.
     */


    /**
     * emit action to be utelized by actionCreator or by UI
     */


    /**
     * used by ui to listen to events
     */

  }, {
    key: "render",
    value: function render() {
      var emit = this.emit,
          listen = this.listen,
          props = this.props;


      return createElement(
        Context.Provider,
        {
          value: {
            store: this.state,
            emit: emit,
            listen: listen,
            selectors: props.selectors // just a proxy to avoid import X form '../../../sdk/MODULE/selectors' shit..
          }
        },
        this.props.children
      );
    }
  }]);
  return ReactPubFlux;
}(Component);

ReactPubFlux.defaultProps = {
  actions: [],
  reducer: function reducer() {
    return console.warn("no reducer supplied");
  }
};


ReactPubFlux.displayName = "Core";
ReactPubFlux.propTypes = {
  reducer: t.func.isRequired,
  actions: t.arrayOf(t.func).isRequired,
  initalState: t.any,
  onChange: t.func
};
ReactPubFlux.defaultProps = {
  reducer: function reducer() {
    return console.error("no reducer supplied to provider"), {};
  },
  actions: []
};
var Connect = Context.Consumer;

function withFlux(Component$$1) {
  return function WrapperComponent(props) {
    return createElement(
      Connect,
      null,
      function (data) {
        var store = data.store;

        var selectors = proxyArgToFns(data.selectors, data.store);
        return createElement(Component$$1, _extends({}, props, isFunction(Component$$1.stateToProps) ? Component$$1.stateToProps(store, selectors, props) : { store: store }, {
          selectors: selectors,
          emit: data.emit,
          listen: data.listen
        }));
      }
    );
  };
}

export default ReactPubFlux;
export { combineReducers, subscribe, withFlux, Connect, ReactPubFlux as Provider };
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 69
// module chunks = 0